module.exports = __webpack_public_path__ + "img/workshop-detail-banner-1600X870.c6b90cea.png";